import { AddNomineeComponent } from './../shared/add-nominee/add-nominee.component';
import { VariableService } from './../services/variable.service';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DashboardService } from '../services/dashboard.service';
import * as Highcharts from 'highcharts';
import { CustomLoaderService } from '../services/custom-loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { EncrdecrService } from '../Auth/encrdecr.service';
import { ClientDataService } from './../services/client-data.service';
import { NseOnboardingService } from './../services/nse-onboarding.service';
import { ProfileService } from '../services/profile.service';
import { ColorsArrayService } from '../services/colors-array.service';
import { SGBBondServiceService } from '../services/sgbbond-service.service';
import { DatePipe } from '@angular/common';
import { UserTrackingService } from '../services/user-tracking.service';
import { TokenExpireService } from '../services/token-expire.service';
import { isNullOrUndefined } from '../validation';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { MainHeaderMenuService } from '../services/main-header-menu.service';
import { LoginService } from '../services/login.service';
import { ReportService } from '../services/report.service';
import { TransactionService } from '../services/transaction.service';

// import { RiskprofileModelComponent } from './../shared/riskprofile-model/riskprofile-model.component'; //Added by Ashwini
// import { DigitalKYCModelComponent } from '../shared/digital-kyc-model/digital-kyc-model.component';

declare var $: any;

@Component({
  selector: 'app-comprehensive-summary',
  templateUrl: './comprehensive-summary.component.html',
  styleUrls: ['./comprehensive-summary.component.scss']
})
export class ComprehensiveSummaryComponent {
  @Input() IsMobile: boolean = false;
  @Input() UserType: string = '3';
  // @Input() UserType: number = 3;

  @Input() ClientBasicInfoId: any;
  @Input() ClientName: string = '';
  @Input() SubBrokerName: string = '';
  @Input() LoggedInUserType = '';
  @Input() FilterData: any;
  @Input() IsShowDashboard: boolean = false;
  @Input() DashboardUserRole = '';
  @Input() IsSelf: boolean = false;


  path: any;
  selectFamilyData: any = [];

  CHAssetWiseData: any = [];
  CHSubassetwiseData: any = [];
  CHAMCWiseData: any = [];
  CHSchemeData: any = [];
  TotalItemValues: any = [];

  RecentPurchasetransactionData_1: any = [];
  RecentRedimtiontransactionData_1: any = [];
  TopmostPurchasetransactionData_1: any = [];
  TopmostRedimtiontransactionData_1: any = [];
  RecentPurchasetransactionData: any = [];
  RecentRedimtiontransactionData: any = [];
  TopmostPurchasetransactionData: any = [];
  TopmostRedimtiontransactionData: any = [];
  SIPDueNext10DaysData: any = [];
  SIPAdditionalLast3MonthsData: any = [];
  SIPEndingNext3MonthsData: any = [];
  SIPTerminateLast3MonthsData: any = [];
  SIPEndingLast3MonthsData: any = [];
  SIPBounceListData: any = [];

  IsRecentTranTab: boolean = true;
  G_ClientBasicInfoId: any;
  G_FamilyId: number;
  DashBoardData: any[];
  //ClientName: string;
  //ClientName: string; rw

  PurchaseValue: any = "0.00";
  CurrentValue: any = "0.00";
  GainLoss: any = "0.00";
  LTCG: string;
  STCG: string;
  XIRR: string = "0.00";
  AbsReturn: string = "0";
  IsShowInvestmentSnapshot: boolean = true;
  AssetWiseData: any[] = [];
  AssetWisedataSource = [];
  AssetWisChartOptions: any = {};
  InitAssetWiseGraph: any;
  totalAssetWise: number;

  SubAssetWiseData: any[] = [];
  SubAssetWisedataSource = [];
  SubAssetWiseChartOptions: any = {};
  InitSubAssetWiseGraph: any;
  totalSubAssetWise: number;

  AMCWiseData: any[] = [];
  AMCWisedataSource = [];
  AMCWiseChartOptions: any = {};
  InitAMCWiseGraph: any;
  totalAMCWise: number;

  SchemeData: any[] = [];
  SchemedataSource = [];
  SchemeChartOptions: any = {};
  InitSchemeGraph: any;
  totalScheme: number;

  SchemData: any[] = [];
  SchemMDatadataSource = [];
  SchemMDataChartOptions: any = {};
  SchemMDataGraph: any;
  totalSchemMData: number;

  divFamily: boolean = false;

  public ColorsArr = [];

  public scrollbarOptions = { axis: 'y', theme: 'dark' };
  public slideConfig = {
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: false,
    autoplay: false,
    speed: 2000,
    nav: true,
    dots: true,
  };
  public slideConfig_Mob = {
    slidesToShow: 1.5,
    //slidesToScroll: 1.5,
    infinite: false,
    autoplay: false,
    speed: 200,
    nav: true,
    dots: false,
    arrows: false
  };
  loginclientId: string;

  Watch_IsEquity: boolean = true;
  Watch_IsHybrid: boolean = false;
  Watch_IsDebt: boolean = false;
  Watch_IsCommodity: boolean = false;
  Performer_IsEquity: boolean = false;
  Performer_IsHybrid: boolean = false;
  Performer_IsDebt: boolean = false;
  Performer_IsCommodity: boolean = false;

  Holdings_Asset: boolean = false;
  Holdings_SubAsset: boolean = false;
  Holdings_AMC: boolean = false;
  Holdings_Scheme: boolean = true;

  Transaction_IsRecentPurchase: boolean = true;
  Transaction_IsRecentRedemption: boolean = false;
  Transaction_IsTopmostPurchase: boolean = false;
  Transaction_IsTopmostRedemption: boolean = false;

  SIP_ISdueinlast10d: boolean = true;
  SIP_ISaddinlast3m: boolean = false;
  SIP_ISendinginnext3m: boolean = false;
  SIP_ISterminatedinlast3m: boolean = false;
  SIP_ISenedinlast3m: boolean = false;
  SIP_ISbouncedinlast: boolean = false;
  IsBse: boolean = true;
  //IsMobile: boolean = false; rw
  ExchangeFlag: string;
  IsShowAllRecentPurchase: boolean = true;
  IsShowAllRecentRedemption: boolean = true;
  IsShowAllTopmostPurchase: boolean = true;
  IsShowAllTopmostRedemption: boolean = true;
  CompanyName: string;
  GeneratedIIN: any;
  IsIINGenerated: boolean = false;
  G_UserType: any;
  G_SubBrokerId: string;
  KYCVerified: boolean = false;
  OFSClient: number;
  RMName: string = "";
  RMContact: string = "";
  RMEmail: string = "";
  TopFundList: any[] = [];
  IsIFA: boolean = false;
  RMInterval: any;
  ClientInterval: any;
  firstName: string = "";
  EnableRiskProfile: string = ""; //Added by Ashwini on 18-Aug-2022
  RiskProfileStatus: string = ""; //Added by Ashwini on 18-Aug-2022

  public bsModelRef: BsModalRef;
  OnInitStart: number = 0;
  ServerCallStart: number = 0;
  ServerCallEnd: number = 0;
  DataRenderEnd: number = 0;
  RiskProfileLevel: any;
  nomineename: any;
  nomineetitle: any;
  Isnominated: boolean;
  IsNotNominated: boolean;
  User_Id: any;
  SelectedMfTab: string;
  IsShowLoader: boolean = true;
  IsRdctcngdsh: boolean = false; //to know is it from change dash board
  //aditya
  // IsClient: boolean = false;

  //Added By Devang Mehta On 14-02-2025
  ClientMandateList: any = [];
  SummaryReportTotal: any = [{
    // totalAmt:0,
    // totalCurrAmount:0,
    // TotalXIRR:0,
    // TotalGainLoss:0
  }];
  G_UCCCode: any;
  // added by ritesh
  ReportData: any = [];
  G_ROLEID: string = "0";

  //End By Devang Mehta

  constructor(private dashboardservice: DashboardService,
    private SGBBondServiceService: SGBBondServiceService,
    private Loader: CustomLoaderService,
    private EncrdecrService: EncrdecrService,
    private router: Router, private route: ActivatedRoute,
    private ClientDataService: ClientDataService,
    private profileService: ProfileService, private datepipe: DatePipe,
    private ColorsArrayService: ColorsArrayService,
    private Logout: TokenExpireService,
    private appVariable: VariableService,
    private bsModelService: BsModalService,
    public ShowHideHeaderMenu: MainHeaderMenuService,
    private LoginService: LoginService,
    private reportservice: ReportService,
    private transaction: TransactionService) { }
  RenderData(MainTab: string, SubTab: string) {
    //////
    switch (MainTab) {
      case 'Holdings':
        switch (SubTab) {
          case 'Asset':
            this.Holdings_Asset = true;
            this.Holdings_SubAsset = false;
            this.Holdings_AMC = false;
            this.Holdings_Scheme = false;
            break;
          case 'SubAsset':
            this.Holdings_Asset = false;
            this.Holdings_SubAsset = true;
            this.Holdings_AMC = false;
            this.Holdings_Scheme = false;
            break;
          case 'AMC':
            this.Holdings_Asset = false;
            this.Holdings_SubAsset = false;
            this.Holdings_AMC = true;
            this.Holdings_Scheme = false;
            break;
          case 'Scheme':
            this.Holdings_Asset = false;
            this.Holdings_SubAsset = false;
            this.Holdings_AMC = false;
            this.Holdings_Scheme = true;
            break;
        }
        break
      case 'Transaction':
        switch (SubTab) {
          case 'recentpurchase':
            this.Transaction_IsRecentPurchase = true;
            this.Transaction_IsRecentRedemption = false;
            this.Transaction_IsTopmostPurchase = false;
            this.Transaction_IsTopmostRedemption = false;
            break;
          case 'recentredemption':
            this.Transaction_IsRecentPurchase = false;
            this.Transaction_IsRecentRedemption = true;
            this.Transaction_IsTopmostPurchase = false;
            this.Transaction_IsTopmostRedemption = false;
            break;
          case 'topmostpurchase':
            this.Transaction_IsRecentPurchase = false;
            this.Transaction_IsRecentRedemption = false;
            this.Transaction_IsTopmostPurchase = true;
            this.Transaction_IsTopmostRedemption = false;
            break;
          case 'topmostredemption':
            this.Transaction_IsRecentPurchase = false;
            this.Transaction_IsRecentRedemption = false;
            this.Transaction_IsTopmostPurchase = false;
            this.Transaction_IsTopmostRedemption = true;
            break;
        }
        break;

      case 'SIP':
        switch (SubTab) {
          case 'dueinlast10d':
            this.SIP_ISdueinlast10d = true;
            this.SIP_ISaddinlast3m = false;
            this.SIP_ISendinginnext3m = false;
            this.SIP_ISterminatedinlast3m = false;
            this.SIP_ISenedinlast3m = false;
            this.SIP_ISbouncedinlast = false;
            break;
          case 'addinlast3m':
            this.SIP_ISdueinlast10d = false;
            this.SIP_ISaddinlast3m = true;
            this.SIP_ISendinginnext3m = false;
            this.SIP_ISterminatedinlast3m = false;
            this.SIP_ISenedinlast3m = false;
            this.SIP_ISbouncedinlast = false;
            break;
          case 'endinginnext3m':
            this.SIP_ISdueinlast10d = false;
            this.SIP_ISaddinlast3m = false;
            this.SIP_ISendinginnext3m = true;
            this.SIP_ISterminatedinlast3m = false;
            this.SIP_ISenedinlast3m = false;
            this.SIP_ISbouncedinlast = false;
            break;
          case 'terminatedinlast3m':
            this.SIP_ISdueinlast10d = false;
            this.SIP_ISaddinlast3m = false;
            this.SIP_ISendinginnext3m = false;
            this.SIP_ISterminatedinlast3m = true;
            this.SIP_ISenedinlast3m = false;
            this.SIP_ISbouncedinlast = false;
            break;
          case 'endedinlast3m':
            this.SIP_ISdueinlast10d = false;
            this.SIP_ISaddinlast3m = false;
            this.SIP_ISendinginnext3m = false;
            this.SIP_ISterminatedinlast3m = false;
            this.SIP_ISenedinlast3m = true;
            this.SIP_ISbouncedinlast = false;
            break;
          case 'bouncedinlast':
            this.SIP_ISdueinlast10d = false;
            this.SIP_ISaddinlast3m = false;
            this.SIP_ISendinginnext3m = false;
            this.SIP_ISterminatedinlast3m = false;
            this.SIP_ISenedinlast3m = false;
            this.SIP_ISbouncedinlast = true;
            break;
        }
        break;
    }
  }
  ConvertToNegative(r: any) {
    let val = '';
    try {
      if (!isNullOrUndefined(r)) {
        r = r.toString();
        if (r.includes('-')) {
          let v = r.replace('-', '');
          val = `(${v})`
        }
        else {
          val = r;
        }
      }
    } catch (error) {
      console.log(error)
    }
    return val;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  ngAfterViewInit() {
    $('select').select2({
      minimumResultsForSearch: -1
    });
    $('#DdlPortfolioAllocation').on('change', function (e) {
      let r = $(this).val();
      $('#PortfolioAllocation .tab-pane').removeClass('show active');
      $('#PortfolioAllocation .tab-pane').eq(r).addClass('show active');
    });
    $('#DdlCurrentHoldings').on('change', function (e) {
      let r = $(this).val();
      $('#CurrentHoldings .tab-pane').removeClass('show active');
      $('#CurrentHoldings .tab-pane').eq(r).addClass('show active');
    });

    this.RMInterval = setInterval(() => {

      if (this.RMName == '') {
        this.RMName = this.appVariable.RmName;
        this.RMContact = this.appVariable.RmContact;
      }
      else {
        clearInterval(this.RMInterval);
      }
    }, 1000)
    this.ClientInterval = setInterval(() => {

      if (this.firstName == '') {
        this.firstName = this.appVariable.ClientName;
      }
      else {
        clearInterval(this.ClientInterval);
      }
    }, 1000)

  }
  ngOnInit() {
    this.Remove()
    sessionStorage.setItem("jtryithsde", "1");
    this.IsRdctcngdsh = !!sessionStorage.getItem('bXHnuiS89&#jk##')
    this.ShowHideHeaderMenu.show();
    this.Loader.show();
    if (sessionStorage.getItem("HLIHOLK332") != undefined && sessionStorage.getItem("HLIHOLK332") != null) {
      let value = sessionStorage.getItem("HLIHOLK332")
      if (value == "FromReport") {
        //$('#ExpandCollapse').trigger('click');
        // $('.MainBg').addClass('collapsed_Menu');
        // $('.MainBg.collapsed_Menu').css('padding-left', '68px');
        $('.MainBg').addClass('collapsed_Menu');
      }
      // sessionStorage.removeItem("HLIHOLK332")
    }
    // if(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null){
    //   this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem('UZT6qHaDZSz66kx'));
    // }
    // this.CompanyName = this.ClientDataService.GetCompanyName();
    // this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));

    // this.BindPageLoadData();

    let Token: string = "";
    let ClientCode: any = "";

    debugger
    this.route.queryParams.subscribe((queryParam) => {
      if (queryParam.cc != undefined) {
        ClientCode = queryParam.cc;
        ClientCode = ClientCode.replaceAll(" ", "+");
      }
      if (queryParam.tt != undefined) {
        Token = queryParam.tt;
      }

      if (Token != "" && ClientCode != "") {
        let request = {
          userId: ClientCode,
          token: Token
        }

        this.LoginService.checkIIFLToken(request).subscribe(
          (response: any) => {
            debugger
            let res = JSON.parse(this.EncrdecrService.getDecr(response))

            if (res.ArrayOfResponse != null && res.ArrayOfResponse != undefined) {
              // if (res.ArrayOfResponse.length === 1 || res.ArrayOfResponse.length >= 1) {
              let password = this.EncrdecrService.getDecr(res.ArrayOfResponse[0].Password)
              const json = {
                "Username": res.ArrayOfResponse[0].PANNo,
                "Password": password
              }
              let databody = JSON.stringify(json);
              this.callAuthenticationController(databody)
              this.Loader.hide();
            } else {
              window.location.href = '/login-cp';
            }
          }, (err: any) => {
            console.log(err);
            this.Loader.hide();
          })
      }
      else {
        if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null) {
          if (sessionStorage.getItem('UZT6qHaDZSz66kx') != null && sessionStorage.getItem('UZT6qHaDZSz66kx') != '') {//condition added by rw
            this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem('UZT6qHaDZSz66kx'));
          }
          else {
            this.G_ClientBasicInfoId = this.ClientBasicInfoId
          }
          this.CompanyName = this.ClientDataService.GetCompanyName();
          this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
          if (!(!!sessionStorage.getItem('bXHnuiS89&#jk##'))) {
            sessionStorage.setItem('thnjiokgrthn', this.EncrdecrService.setEncr(this.G_ClientBasicInfoId)); // Session_ClientBasicInfoId,aditya
            sessionStorage.setItem('edcrfvbhunji', this.EncrdecrService.setEncr(this.G_UserType)); // Session_client userType,aditya
          }

          this.BindPageLoadData();
        } else {
          window.location.href = '/login-cp';
        }
      }
    });
    if (this.G_UserType == 3) {
      this.GetUCCCode(this.EncrdecrService.getDecr(sessionStorage.getItem("UZT6qHaDZSz66kx")))
    }
    this.GetSummaryReport();

  }


  callAuthenticationController(DataBody: any) {
    sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    this.LoginService.PostLogin_NSE_Info(DataBody, 3, IpAddress).then(
      (res1: any) => {
        let resMessage = "";
        let res = JSON.parse(this.EncrdecrService.getDecr(res1));
        if (!isNullOrUndefined(res.Message)) {
          resMessage = res.Message;
        }
        else {
          resMessage = res;
        }
        if (resMessage != "Invalid Username and Password" && res.TOKEN_ID != null) {
          sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
          sessionStorage.setItem('YKHkxDnoSoOe6PdTjKrqfm4z6', this.EncrdecrService.setEncr("19"));
          sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
          sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); // Session_SubBrokerId
          sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); // Session_UserName
          sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); // Session_UserEmail

          sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); // Session_UserMobile
          sessionStorage.setItem('pOWgAF62qFXnZMn', ''); // RazorCustId
          sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); // Session_SubBrokerCode
          sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); // Session_UserType
          sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); // Session_CBId
          sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); // Session_B64CompanyLogo
          if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
            sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  // Session_Family_ID
          }
          let ut = res.USER_TYPE;
          if (ut != undefined && ut != null && ut != '') {
            if (this.EncrdecrService.getDecr(ut) == '3') {
              sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID);
              this.User_Id = res.USER_ID;
              sessionStorage.setItem('UZT6qHaDZSz66kx', res.LOGIN_ID); // Session_ClientBasicInfoId
              sessionStorage.setItem('N1QJHdOkO7Hz8QC', res.LOGIN_ID);
              sessionStorage.setItem('ySxterqMDG7RY2qTpuzrfA', this.EncrdecrService.setEncr("1"));

              sessionStorage.setItem('AqVk7klfa+b0nlVjO8Y90I=', res.RiskProfile); //Aggressive/Moderate etc
              sessionStorage.setItem('aaIHl0pIiYe71gyyxC/5xA==', res.RiskProfileStatus);//Active or Expired
              sessionStorage.setItem('LWHTWnSDkv4+qaQXsO6tHYU=', res.RiskProfileLevel); //risk Level of client
              sessionStorage.setItem('6l0NqN5kkIZCaDvdzUfYVK8g=', res.RiskProfileInsertedDate)
              this.Loader.hide();

              sessionStorage.setItem("3erT@Qr65TdXwq1", res.LOGIN_ID);
              //Microsoft Clarity Code Starts
              let id = res.USER_ID;

              if (id != null && id != undefined && id != '') {
                id = this.EncrdecrService.getDecr(id);
                sessionStorage.removeItem('cl2342wrty'); ///21062024
                sessionStorage.setItem('cl2342wrty', id)
              }


              this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem('UZT6qHaDZSz66kx'));

              this.CompanyName = this.ClientDataService.GetCompanyName();
              this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
              if (!(!!sessionStorage.getItem('bXHnuiS89&#jk##'))) {
                sessionStorage.setItem('thnjiokgrthn', this.EncrdecrService.setEncr(this.G_ClientBasicInfoId)); // Session_ClientBasicInfoId,aditya
                sessionStorage.setItem('edcrfvbhunji', this.EncrdecrService.setEncr(this.G_UserType)); // Session_client userType,aditya
              }
              this.BindPageLoadData();
            }
            else {
              this.CallAlertModal('Please enter valid username and password');
            }
          }
          else {
            this.CallAlertModal('Please enter valid username and password');
          }
        }
        else if (resMessage.includes("This feature is not available for your login")) {
          // this.CallAlertModal(resMessage);
          this.CallAlertModal("To activate your login, please contact your distributor")
        }
        else {
          this.CallAlertModal('Please enter valid username and password');
        }
        this.Loader.hide();
      },
      (err: any) => {
        const rr = err.error;
        const er = rr.substring(1, rr.length - 1);
        const rk = er.split(', ');
        this.Loader.hide();
        this.CallAlertModal('Please enter valid username and password');
      }
    );
  }

  GetTopFundsData() {
    this.Loader.show();
    this.dashboardservice.GetTopFund(this.ExchangeFlag).subscribe(
      (res: any) => {
        this.Loader.hide();
        res = JSON.parse(this.EncrdecrService.getDecr(res))
        this.TopFundList = res.ArrayOfResponse.sort((a, b) => a.CLASSCode - b.CLASSCode);
        console.log(this.TopFundList)
      });
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
    if (this.IsShowInvestmentSnapshot && !this.IsMobile) {
      $('.TopPerformimgFunds').css('width', $('.AMCChartsInner').css('width'));
    }
    else {
      $('.TopPerformimgFunds').css('width', 'auto');
    }
    // if (!this.IsShowInvestmentSnapshot && !this.IsMobile) {
    //   $('.TopPerformimgFundsNoInvest').css('width', $('.QuickTransactNoInvest').css('width'));
    // }
    // if (this.IsMobile) {
    //   $('.TopPerformimgFunds').css('width', w - 38);
    // }
  }
  GetFamilyGroup(familyGroupId) {
    //////
    if (familyGroupId != 0) {
      this.divFamily = true;
      this.dashboardservice.GetFamilyGroupDetail(familyGroupId).subscribe(
        (result: any) => {

          if (result != null) {
            if (result.Message != null && result.Message != '' && result.Message.indexOf('Not Authorized') > -1) {
              this.Loader.hide();
              this.Logout.LogoutUser();
              return;
            }
            else {
              this.selectFamilyData = result.ArrayOfResponse;
            }
          }
        });
    }
    else {
      this.divFamily = false;
      this.ClientName = this.EncrdecrService.getDecr(sessionStorage.getItem('V4WGROuLLBE6t98'));
    }


  }
  GoTOCalculator(menu: string) {
    ////////
    sessionStorage.setItem('QZqm364MawmIcSC', this.EncrdecrService.setEncr(menu)); // SelectedMenu
    this.router.navigate(['/calculators'], { relativeTo: this.route })
  }
  // GotoGoalPlaning(menu: string) {
  //   ////////
  //
  //   sessionStorage.setItem('wcgJs7/ETpjyiKOglEgdp', this.EncrdecrService.setEncr(menu)); // SelectedMenu
  //   this.router.navigate(['/goal-planning-bse'], { relativeTo: this.route })
  // }

  getSum(total, num) {
    return total + Math.round(num);
  }

  onChangeClient(event) {
    let clientId = event.target.value;
    this.GetClientDashboardDetail(clientId);
  }

  GetClientDashboardDetail(clientId) {
    this.cleardata();
    if (clientId == 0) {
      if (this.G_FamilyId == undefined) {
        this.G_FamilyId = 0;
      }

      this.dashboardservice.GetFamilyDashboardDetail(this.G_FamilyId).subscribe(
        (result: any) => {
          debugger
          if (result != null) {

            if (result.Message != null && result.Message != '' && result.Message.indexOf('Not Authorized') > -1) {
              this.Loader.hide();
              this.Logout.LogoutUser();
              return;
            }
            else {
              this.DashBoardData = result;
              if (result.ArrayOfResponse.length > 0) {
                this.PurchaseValue = Math.round(+(result.ArrayOfResponse[0].TotalHoldingSummary[0].Amount));
                this.CurrentValue = Math.round(+(result.ArrayOfResponse[0].TotalHoldingSummary[0].CurrentValue));
                this.GainLoss = Math.round(+(result.ArrayOfResponse[0].TotalHoldingSummary[0].Gain));
                this.LTCG = result.ArrayOfResponse[0].TotalHoldingSummary[0].Dividend;
                this.STCG = result.ArrayOfResponse[0].TotalHoldingSummary[0].DividendPaid;
                this.XIRR = result.ArrayOfResponse[0].TotalHoldingSummary[0].XIRR;
                this.AbsReturn = result.ArrayOfResponse[0].TotalHoldingSummary[0].AbsReturn;

                this.BindChartAndData(result);
              }
            }
          }
          else {
            //alert("Subbroker not found.");
          }
          if (this.PurchaseValue !== '0.00' && this.CurrentValue !== '0.00' && this.GainLoss !== '0.00' && this.XIRR !== '0.00' && this.AbsReturn !== '0.00') {
            this.IsShowInvestmentSnapshot = true;
          }
          else {
            this.IsShowInvestmentSnapshot = false;
          }
          this.SetViewPort(window.innerWidth);
          this.Loader.hide();
        },
        err => {
          //console.log(err)
          this.Loader.hide();
        });
    }
    else {
      this.ServerCallStart = new Date().getTime();
      //;

      debugger
      this.dashboardservice.GetClientDashboardDetail(clientId).then(
        (result1: any) => {
          //;
          debugger
          let result = JSON.parse(this.EncrdecrService.getDecr(result1));
          this.ServerCallEnd = new Date().getTime();
          if (result.Message != null && result.Message != '' && result.Message.indexOf('Not Authorized') > -1) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          }
          else {
            let rr = result.ArrayOfResponse[0].ClientWiseHoldingSummary;
            if (rr.length > 0) {
              this.DashBoardData = result;
              this.PurchaseValue = Math.round(+(rr[0].Amount));
              this.CurrentValue = Math.round(+(rr[0].CurrentValue));
              this.GainLoss = Math.round(+(rr[0].Gain));
              this.LTCG = rr[0].Dividend;
              this.STCG = rr[0].DividendPaid;
              this.XIRR = rr[0].XIRR;
              this.AbsReturn = rr[0].AbsReturn;

              this.BindChartAndData(result);

            }
            else {
              this.IsShowLoader = false;
              // setTimeout(()=>{

              //   if(this.IsBse && this.OFSClient != 4){
              //     $('#NoHoldingsModal').modal({
              //       backdrop: 'static',
              //       keyboard: false
              //     });
              //   }
              // },1500);
            }
            if (this.PurchaseValue !== '0.00' && this.CurrentValue !== '0.00' && this.GainLoss !== '0.00' && this.XIRR !== '0.00' && this.AbsReturn !== '0.00' && this.AbsReturn !== '0') {
              this.IsShowInvestmentSnapshot = true;
            }
            else {
              this.IsShowInvestmentSnapshot = false;
            }
            this.SetViewPort(window.innerWidth);
            this.Loader.hide();
          }
        },
        err => {
          //console.log(err)
          this.Loader.hide();
        });
    }
  }

  cleardata() {
    this.PurchaseValue = "0.00";
    this.CurrentValue = "0.00";
    this.GainLoss = "0.00";
    this.LTCG = "0.00";
    this.STCG = "0.00";
    this.XIRR = "0.00";
    this.AbsReturn = "0";
    this.CHAssetWiseData = [];
    this.CHSubassetwiseData = [];
    this.CHAMCWiseData = [];
    this.CHSchemeData = [];

    this.RecentPurchasetransactionData_1 = [];
    this.RecentRedimtiontransactionData_1 = [];
    this.TopmostPurchasetransactionData_1 = [];
    this.TopmostRedimtiontransactionData_1 = [];
    this.RecentPurchasetransactionData = [];
    this.RecentRedimtiontransactionData = [];
    this.TopmostPurchasetransactionData = [];
    this.TopmostRedimtiontransactionData = [];

    this.SIPDueNext10DaysData = [];
    this.SIPAdditionalLast3MonthsData = [];
    this.SIPEndingNext3MonthsData = [];
    this.SIPTerminateLast3MonthsData = [];
    this.SIPEndingLast3MonthsData = [];
    this.SIPBounceListData = [];


    this.AssetWisedataSource.length = 0;
    this.AssetWiseData = [];
    this.AMCWisedataSource.length = 0;
    this.AMCWiseData = [];
    this.SchemedataSource.length = 0;
    this.SchemeData = [];
  }

  BindChartAndData(result) {
    debugger
    this.IsShowLoader = true;
    this.CHAssetWiseData = result.ArrayOfResponse[0].AssetWiseHolding;
    this.CHAssetWiseData = this.CHAssetWiseData.slice(0, 10);

    this.CHSubassetwiseData = result.ArrayOfResponse[0].SubAssetWiseHolding;
    this.CHSubassetwiseData = this.CHSubassetwiseData.slice(0, 10);

    this.CHAMCWiseData = result.ArrayOfResponse[0].AMCWiseHolding;
    this.CHAMCWiseData = this.CHAMCWiseData.slice(0, 10);

    this.CHSchemeData = result.ArrayOfResponse[0].SchemeWiseHolding;
    this.CHSchemeData = this.CHSchemeData.slice(0, 10);
    //----------------------------------------------------------------------------------------------------------
    this.RecentPurchasetransactionData_1 = result.ArrayOfResponse[0].PurchaseRecentTransaction;
    this.RecentPurchasetransactionData = this.RecentPurchasetransactionData_1.slice(0, 5);

    this.RecentRedimtiontransactionData_1 = result.ArrayOfResponse[0].RedemptionRecentTransaction;
    this.RecentRedimtiontransactionData = this.RecentRedimtiontransactionData_1.slice(0, 5);

    this.TopmostPurchasetransactionData_1 = result.ArrayOfResponse[0].TopMostPurTransaction;
    this.TopmostPurchasetransactionData = this.TopmostPurchasetransactionData_1.slice(0, 5);

    this.TopmostRedimtiontransactionData_1 = result.ArrayOfResponse[0].TopMostRedemTransaction;
    this.TopmostRedimtiontransactionData = this.TopmostRedimtiontransactionData_1.slice(0, 5);
    //----------------------------------------------------------------------------------------------------------
    this.SIPDueNext10DaysData = result.ArrayOfResponse[0].SIPDueNext10Days;
    this.SIPDueNext10DaysData = this.SIPDueNext10DaysData.slice(0, 10);

    this.SIPAdditionalLast3MonthsData = result.ArrayOfResponse[0].SIPAdditionalLast3Months;
    this.SIPAdditionalLast3MonthsData = this.SIPAdditionalLast3MonthsData.slice(0, 10);

    this.SIPEndingNext3MonthsData = result.ArrayOfResponse[0].SIPEndingNext3Months;
    this.SIPEndingNext3MonthsData = this.SIPEndingNext3MonthsData.slice(0, 10);

    this.SIPTerminateLast3MonthsData = result.ArrayOfResponse[0].SIPTerminateLast3Months;
    this.SIPTerminateLast3MonthsData = this.SIPTerminateLast3MonthsData.slice(0, 10);

    this.SIPEndingLast3MonthsData = result.ArrayOfResponse[0].SIPEndingLast3Months;
    this.SIPEndingLast3MonthsData = this.SIPEndingLast3MonthsData.slice(0, 10);

    this.SIPBounceListData = result.ArrayOfResponse[0].SIPBounceList;
    this.SIPBounceListData = this.SIPBounceListData.slice(0, 10);

    /***********************AssestwiseAUM**************** */
    this.AssetWisedataSource.length = 0;
    let TempAssetWiseData = result.ArrayOfResponse[0].AssetWiseHolding;
    if (TempAssetWiseData.length > 0) {
      this.AssetWiseData = TempAssetWiseData.sort((a, b) => b.CurrentAUM - a.CurrentAUM);
      this.totalAssetWise = this.AssetWiseData.reduce((total, per) => total + per.CurrentValue, 0);
      let i: number = 0;
      this.AssetWiseData.map((arr, index) => {
        let rr: any = {};
        rr.name = (arr.AssetType != '' ? arr.AssetType : '-');
        rr.id = (arr.AssetType != '' ? arr.AssetType : '-');
        rr.y = +(!isNaN(parseFloat(arr.CurrentValue)) ? parseFloat(arr.CurrentValue).toFixed(2) : 0);
        rr.color = this.ColorsArr[i];
        let tempper = (parseFloat((Math.abs(rr.y / this.totalAssetWise) * 100).toFixed(2))).toString();
        let tempper1 = tempper.split('.')
        if (tempper1[0].toString().length == 1) {
          tempper = "0" + tempper;
        }
        rr.ShowPer = tempper;
        rr.percentage = parseFloat((Math.abs(rr.y / this.totalAssetWise) * 100).toFixed(2));
        rr.IndCurrVal = this.ConvertToIndianRsWithDecimal(+(!isNaN(parseFloat(arr.CurrentValue)) ? parseFloat(arr.CurrentValue).toFixed(2) : 0));
        this.AssetWisedataSource.push(rr);
        if (i == 14) {
          i = 0;
        } else {
          i += 1;
        }
      })
      this.AssetWisChartOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        title: {
          text: ""
        },
        credits: {
          enabled: false
        },
        tooltip: {
          pointFormat: '{series.name} <b>₹{point.IndCurrVal}</b><b> | </b> <b>{point.ShowPer}%</b>'
        },
        series: [
          {
            name: '',
            data: this.AssetWisedataSource
          }
        ],
        plotOptions: {
          pie: {
            startAngle: 90,
            innerSize: "70%",
            size: "100%",
            dataLabels: !1,
            stickyTracking: !1,
            slicedOffset: 10,
            states: {
              hover: {
                enabled: !1
              },
              inactive: {
                opacity: 1
              }
            },
            point: {
              events: {
                mouseOver: function () {
                  this.slice();
                  $(".AddHoverEffect").removeClass("hoveredThis"),
                    $(".AddHoverEffect[id='" + this.name + "']").addClass("hoveredThis");
                },
                mouseOut: function () {
                  this.slice();
                  $(".AddHoverEffect").removeClass("hoveredThis");
                }
              }
            }
          }
        }
      };
      this.InitAssetWiseGraph = Highcharts.chart("AssetWiseGraph", this.AssetWisChartOptions);
    }
    /***********************AssestwiseAUM*************** */

    /************************SubAsseswise****************** */
    this.SubAssetWisedataSource.length = 0;
    let TempSubAssetWiseData = result.ArrayOfResponse[0].SubAssetWiseHolding;
    if (TempSubAssetWiseData.length > 0) {
      this.SubAssetWiseData = TempSubAssetWiseData.sort((a, b) => b.CurrentAUM - a.CurrentAUM);
      this.totalSubAssetWise = this.SubAssetWiseData.reduce((total, per) => total + per.CurrentValue, 0);
      let i: number = 0;
      this.SubAssetWiseData.map((arr, index) => {
        let rr: any = {};
        rr.name = (arr.AssetType != '' ? arr.AssetType : '-');
        rr.id = (arr.AssetType != '' ? arr.AssetType : '-');
        rr.y = +(!isNaN(parseFloat(arr.CurrentValue)) ? parseFloat(arr.CurrentValue).toFixed(2) : 0);
        rr.color = this.ColorsArr[i];
        let tempper = (parseFloat((Math.abs(rr.y / this.totalSubAssetWise) * 100).toFixed(2))).toString();
        let tempper1 = tempper.split('.')
        if (tempper1[0].toString().length == 1) {
          tempper = "0" + tempper;
        }
        rr.ShowPer = tempper;
        rr.percentage = parseFloat((Math.abs(rr.y / this.totalSubAssetWise) * 100).toFixed(2));
        rr.IndCurrVal = this.ConvertToIndianRsWithDecimal(+(!isNaN(parseFloat(arr.CurrentValue)) ? parseFloat(arr.CurrentValue).toFixed(2) : 0));
        this.SubAssetWisedataSource.push(rr);
        if (i == 14) {
          i = 0;
        } else {
          i += 1;
        }
      });


      this.SubAssetWiseChartOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        title: {
          text: ""
        },
        credits: {
          enabled: false
        },
        tooltip: {
          pointFormat: '{series.name} <b>₹{point.IndCurrVal}</b> <b> | </b> <b>{point.ShowPer}%</b>'
        },
        series: [
          {
            name: '',
            data: this.SubAssetWisedataSource
          }
        ],
        plotOptions: {
          pie: {
            startAngle: 90,
            innerSize: "70%",
            size: "100%",
            dataLabels: !1,
            stickyTracking: !1,
            slicedOffset: 10,
            states: {
              hover: {
                enabled: !1
              },
              inactive: {
                opacity: 1
              }
            },
            point: {
              events: {
                mouseOver: function () {
                  this.slice();

                  $(".AddHoverEffect").removeClass("hoveredThis"),
                    $(".AddHoverEffect[id='" + this.name + "']").addClass("hoveredThis");
                },
                mouseOut: function () {
                  this.slice();
                  $(".AddHoverEffect").removeClass("hoveredThis");
                }
              }
            }
          }
        }
      };

      this.InitSubAssetWiseGraph = Highcharts.chart("SubAssetWiseGraph", this.SubAssetWiseChartOptions);
    }
    /********SubAssestChart***************/


    /***********************AMCWiseAUM**************** */
    this.AMCWisedataSource.length = 0;
    let TempAMCWiseData = result.ArrayOfResponse[0].AMCWiseHolding;
    if (TempAMCWiseData.length > 0) {
      this.AMCWiseData = TempAMCWiseData.sort((a, b) => b.CurrentAUM - a.CurrentAUM);
      this.totalAMCWise = this.AMCWiseData.reduce((total, per) => total + per.CurrentValue, 0);
      let i: number = 0;

      this.AMCWiseData.map((arr, index) => {
        let rr: any = {};
        rr.name = (arr.AssetType != '' ? arr.AssetType : '-');
        rr.id = (arr.AssetType != '' ? arr.AssetType : '-');
        rr.y = +(!isNaN(parseFloat(arr.CurrentValue)) ? parseFloat(arr.CurrentValue).toFixed(2) : 0);
        rr.color = this.ColorsArr[i];
        let tempper = (parseFloat((Math.abs(rr.y / this.totalAMCWise) * 100).toFixed(2))).toString();
        let tempper1 = tempper.split('.')
        if (tempper1[0].toString().length == 1) {
          tempper = "0" + tempper;

        }
        rr.ShowPer = tempper;
        rr.percentage = parseFloat((Math.abs(rr.y / this.totalAMCWise) * 100).toFixed(2)).toFixed(2);
        rr.IndCurrVal = this.ConvertToIndianRsWithDecimal(+(!isNaN(parseFloat(arr.CurrentValue)) ? parseFloat(arr.CurrentValue).toFixed(2) : 0));
        this.AMCWisedataSource.push(rr);
        if (i == 14) {
          i = 0;
        } else {
          i += 1;
        }
      });
      console.log(this.AMCWisedataSource);
      this.AMCWiseChartOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        title: {
          text: ""
        },
        credits: {
          enabled: false
        },
        tooltip: {
          pointFormat: '{series.name} <b>₹{point.IndCurrVal}</b> <b> | </b> <b>{point.ShowPer}%</b>'
        },
        series: [
          {
            name: '',
            data: this.AMCWisedataSource
          }
        ],
        plotOptions: {
          pie: {
            startAngle: 90,
            innerSize: "70%",
            size: "100%",
            dataLabels: !1,
            stickyTracking: !1,
            slicedOffset: 10,
            states: {
              hover: {
                enabled: !1
              },
              inactive: {
                opacity: 1
              }
            },
            point: {
              events: {
                mouseOver: function () {
                  this.slice();

                  $(".AddHoverEffect").removeClass("hoveredThis"),
                    $(".AddHoverEffect[id='" + this.name + "']").addClass("hoveredThis");
                },
                mouseOut: function () {
                  this.slice();
                  $(".AddHoverEffect").removeClass("hoveredThis");
                }
              }
            }
          }
        }
      };

      this.InitAMCWiseGraph = Highcharts.chart("AMCWiseGraph", this.AMCWiseChartOptions);
    }
    /***********************AMCWiseAUM*************** */

    /***********************Scheme**************** */
    this.SchemedataSource.length = 0;
    let TempSchemeData = result.ArrayOfResponse[0].SchemeWiseHolding;
    if (TempSchemeData.length > 0) {
      this.SchemeData = TempSchemeData.sort((a, b) => b.CurrentAUM - a.CurrentAUM);
      this.totalScheme = this.SchemeData.reduce((total, per) => total + per.CurrentValue, 0);
      let i: number = 0;
      this.SchemeData.map((arr, index) => {
        let rr: any = {};
        rr.name = (arr.AssetType != '' ? arr.AssetType : '-');
        rr.id = (arr.AssetType != '' ? arr.AssetType : '-');
        rr.y = +(!isNaN(parseFloat(arr.CurrentValue)) ? parseFloat(arr.CurrentValue).toFixed(2) : 0);
        rr.color = this.ColorsArr[i];
        let tempper = (parseFloat((Math.abs(rr.y / this.totalScheme) * 100).toFixed(2))).toString();
        let tempper1 = tempper.split('.')
        if (tempper1[0].toString().length == 1) {
          tempper = "0" + tempper;

        }
        rr.ShowPer = tempper;
        rr.percentage = parseFloat((Math.abs(rr.y / this.totalScheme) * 100).toFixed(2));
        rr.IndCurrVal = this.ConvertToIndianRsWithDecimal(+(!isNaN(parseFloat(arr.CurrentValue)) ? parseFloat(arr.CurrentValue).toFixed(2) : 0));
        this.SchemedataSource.push(rr);
        if (i == 14) {
          i = 0;
        } else {
          i += 1;
        }
      })
      this.SchemeChartOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        title: {
          text: ""
        },
        credits: {
          enabled: false
        },
        tooltip: {
          name: '',
          pointFormat: '{series.name} <b>₹{point.IndCurrVal}</b> <b> | </b> <b>{point.ShowPer}%</b>'
        },
        series: [
          {
            name: '',
            data: this.SchemedataSource
          }
        ],
        plotOptions: {
          pie: {
            startAngle: 90,
            innerSize: "70%",
            size: "100%",
            dataLabels: !1,
            stickyTracking: !1,
            slicedOffset: 10,
            states: {
              hover: {
                enabled: !1
              },
              inactive: {
                opacity: 1
              }
            },
            point: {
              events: {
                mouseOver: function () {
                  this.slice();

                  $(".AddHoverEffect").removeClass("hoveredThis"),
                    $(".AddHoverEffect[id='" + this.name + "']").addClass("hoveredThis");
                },
                mouseOut: function () {
                  this.slice();
                  $(".AddHoverEffect").removeClass("hoveredThis");
                }
              }
            }
          }
        }
      };

      this.InitSchemeGraph = Highcharts.chart("SchemeGraph", this.SchemeChartOptions);
    }
    this.DataRenderEnd = new Date().getTime();
    let ServerTime = (this.ServerCallEnd - this.ServerCallStart) / 1000;
    let DataRenderTime = (this.DataRenderEnd - this.ServerCallEnd) / 1000;
    localStorage.setItem('OnInitStart', `${JSON.stringify(this.OnInitStart)}`);
    localStorage.setItem('ServerCallStart', `${JSON.stringify(this.ServerCallStart)}`);
    localStorage.setItem('ServerCallEnd', `${JSON.stringify(this.ServerCallEnd)}`);
    localStorage.setItem('DataRenderEnd', `${JSON.stringify(this.DataRenderEnd)}`);
    localStorage.setItem('ServerTime', `${JSON.stringify(ServerTime)}`);
    localStorage.setItem('DataRenderTime', `${JSON.stringify(DataRenderTime)}`);
    /***********************Scheme*************** */
    this.IsShowLoader = false;
  }
  ShowAllRecentPurchase(t, r) {
    switch (t) {
      case '1':
        this.IsShowAllRecentPurchase = !this.IsShowAllRecentPurchase;
        if (r == '0') {
          this.RecentPurchasetransactionData = this.RecentPurchasetransactionData_1.slice(0, 10);
        }
        else {
          this.RecentPurchasetransactionData = this.RecentPurchasetransactionData_1.slice(0, 5);
        }
        break;
      case '2':
        this.IsShowAllRecentRedemption = !this.IsShowAllRecentRedemption;
        if (r == '0') {
          this.RecentRedimtiontransactionData = this.RecentRedimtiontransactionData_1.slice(0, 10);
        }
        else {
          this.RecentRedimtiontransactionData = this.RecentRedimtiontransactionData_1.slice(0, 5);
        }
        break;
      case '3':
        this.IsShowAllTopmostPurchase = !this.IsShowAllTopmostPurchase;
        if (r == '0') {
          this.TopmostPurchasetransactionData = this.TopmostPurchasetransactionData_1.slice(0, 10);
        }
        else {
          this.TopmostPurchasetransactionData = this.TopmostPurchasetransactionData_1.slice(0, 5);
        }
        break;
      case '4':
        this.IsShowAllTopmostRedemption = !this.IsShowAllTopmostRedemption;
        if (r == '0') {
          this.TopmostRedimtiontransactionData = this.TopmostRedimtiontransactionData_1.slice(0, 10);
        }
        else {
          this.TopmostRedimtiontransactionData = this.TopmostRedimtiontransactionData_1.slice(0, 5);
        }
        break;
    }

  }
  ToggleIsRecentTab() {
    this.IsRecentTranTab = !this.IsRecentTranTab;
  }
  ConvertToIndianRsWithDecimal(IpAmount: any) {
    return IpAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  redirectToTransaction() {
    sessionStorage.setItem('Shv3IZ7dNAGND6w', this.EncrdecrService.setEncr('638G'));
    // 71B
    sessionStorage.setItem('c1er1RAHrEZBEUH', this.EncrdecrService.setEncr('L'));//B
    this.router.navigate(['/transact/lumpsum'], { relativeTo: this.route });
  }
  GotoProfile() {
    let CType = '';
    sessionStorage.setItem('vchys865#$snhds877', 'Y');
    this.router.navigate(['/client-nse'], { relativeTo: this.route });

  }
  GoTOElec(menu: string) {
    sessionStorage.setItem('Xb5weBH3kMGpXLalI+XRHFOQC1EGQdxNnlRDOXZ9nNE=', this.EncrdecrService.setEncr(menu)); // SelectedMenu
    if (this.ExchangeFlag == "B" || this.ExchangeFlag == "BSE") {
      this.router.navigate(['/goal-planning-bse'], { relativeTo: this.route });
    }
    else {
      this.router.navigate(['/goal-planning'], { relativeTo: this.route });
    }

  }

  GoToExploreFunds(para: string) {

    sessionStorage.setItem('Xb5weBH3kMGpXLalI=', para);
    if (this.ExchangeFlag == "B" || this.ExchangeFlag == "BSE") {
      this.router.navigate(['/explore-funds'], { relativeTo: this.route });
    }
    else {
      this.router.navigate(['/explore-funds-n'], { relativeTo: this.route });
    }
  }
  GoToLumpsumByTopFund(r: any) {
    //
    sessionStorage.setItem('Xb0heBk3kWGpXLolI=', this.EncrdecrService.setEncr(JSON.stringify(r)));
    if (this.ExchangeFlag == "B" || this.ExchangeFlag == "BSE") {
      this.router.navigate(['/transaction/lumpsum'], { relativeTo: this.route });
    }
    else {
      this.router.navigate(['/transact/lumpsum'], { relativeTo: this.route });
    }
  }

  GetSGBBondMaster() {
    this.SGBBondServiceService.GetClientSGBDematMaster().subscribe(
      (result: any) => {

        console.log(result);
        if (result != null) {
          if (result.ArrayOfResponse != null && result.ArrayOfResponse.length > 0) {
            if (result.ArrayOfResponse[0].SGB_BondName != null && result.ArrayOfResponse[0].SGB_BondName != "") {
              if (sessionStorage.getItem('%^&s8g9b!@fla%g') != null && sessionStorage.getItem('%^&s8g9b!@fla%g') != "" && sessionStorage.getItem('%^&s8g9b!@fla%g') == "Yes") {
                $('#lblschemename').text(result.ArrayOfResponse[0].SGB_BondName);
                // $('#lblseries').text(result.ArrayOfResponse[0].SGB_Series);
                // $('#lblprice').text(result.ArrayOfResponse[0].SGB_Price);
                $('#lbldate').text(this.datepipe.transform(result.ArrayOfResponse[0].SGB_OpenDate.toString(), "dd-MMM-yyyy") + " TO " + this.datepipe.transform(result.ArrayOfResponse[0].SGB_CloseDate.toString(), "dd-MMM-yyyy"));
                $("#SGBInvest").modal('show');
              }
            }

          }
        }
      });

  }
  OnInvestSGB() {
    //$('#MahindraInvestnowBannerModal').modal('hide');
    $("#SGBInvest").modal('hide');

    this.router.navigateByUrl('SGB/SGBInvest');

  }
  RedirectTo(obj, key) {
    debugger
    const pan = this.G_SubBrokerId.trim();
    sessionStorage.setItem('ROUdocYCPa', this.EncrdecrService.setEncr(obj.AssetCode));
    sessionStorage.setItem('7N0vMeFeQg', this.EncrdecrService.setEncr(obj.FolioNumber));
    sessionStorage.setItem('ea60m0rIgd', this.EncrdecrService.setEncr(obj.AssetType));
    sessionStorage.setItem('uyJH74HsjUtgrhn', this.IsRdctcngdsh ?
      sessionStorage.getItem('thnjiokgrthn') : this.EncrdecrService.setEncr(this.G_ClientBasicInfoId));
    sessionStorage.setItem('iji74GSSbds', this.EncrdecrService.setEncr(pan));

    switch (key) {
      case 0:
        this.router.navigate(['/transaction-new-latest/sip'], { relativeTo: this.route });
        break;
      case 1:
        this.router.navigate(['/transaction-new-latest/lumpsum'], { relativeTo: this.route });
        break;
      case 2:
        this.router.navigate(['/transaction-new-latest/switch'], { relativeTo: this.route });
        break;
      case 3:
        this.router.navigate(['/transaction-new-latest/redeem'], { relativeTo: this.route });
        break;
      default:
        break;
    }
  }
  ToggleShowHideMoreMenu(id: number) {

    $('.TblMoreMenuOuter').removeClass('Open').addClass('Close');
    $('#' + id).parents('tr').removeClass('SelectedTr');
    if ($('#' + id).hasClass('Open')) {
      $('#' + id).removeClass('Open').addClass('Close');
    } else {
      $('#' + id).addClass('Open').removeClass('Close');
      $('#' + id).parents('tr').addClass('SelectedTr');
    }
  }
  onClickOutSide(event) {
    $(document).mouseup(function (e) {
      var container = $(".TblMoreMenuOuter");
      if (!container.is(e.target) &&
        container.has(e.target).length === 0) {
        $('.TblMoreMenuOuter').removeClass('Open').addClass('Close');
        $('tr').removeClass('SelectedTr');
      }
    });
  }
  CallAlertModal(msg: any) {
    $("#AlertModal").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent').text(msg);
  }
  getNomineeStatus() {
    const request = {
      ClientBasicInfo: this.G_ClientBasicInfoId,
      DeclarationFlag: "",
    }
    this.profileService.GetNomineeStatus(JSON.stringify(request)).subscribe((res) => {
      if (res.ID == 0 && res.Message == "Nominee Not Exists") {
        this.BindNomineeData();
      }
    }, ((err) => {
      this.Loader.hide();
    }));
  }
  OpenNomineePopup() {
    this.bsModelRef = this.bsModelService.show(AddNomineeComponent, {
      class: "modal-width380 modal-dialog-centered filter-popup-wrapper",
      ignoreBackdropClick: true,
    });
    this.bsModelRef.content.onClose = new Subject<boolean>();
    this.bsModelRef.content.action = new Subject<boolean>();
    this.bsModelRef.content.onClose.subscribe((res) => {
      if (res == true) {
        this.CallAlertModal("Nominee details updated successfully.");
      }
    });
    this.bsModelRef.content.action.subscribe((res) => {
      if (res == true) {

      }
    });
  }
  SkipNomineeDetails() {
    this.CallNomineeSkipModal('You have chosen to opt-out from nomination. As per SEBI guidelines, you will need to submit a physical declaration for each folio with respective AMC for opting out of nomination. In case this declaration is not provided, redemptions will not be allowed from the scheme. Please reach out to your nearest branch for the declaration form.');
    //this.SetActiveTab('BankDetails');
  }
  CallNomineeSkipModal(msg: any) {
    $("#NomineeDeclarationModel").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#NomineeDeclarationModelContentmodels').text(msg);
  }
  NomineeDeclaration() {
    const request = {
      ClientBasicInfo: this.G_ClientBasicInfoId,
      NomineeDeclarationFlag: 'Yes'
    }
    this.profileService.UpdateNomineeDeclaration(JSON.stringify(request)).subscribe((res) => {
      if (res.ID == 0) {
        this.CallAlertModal(res.Message)
      }
    }, (error) => {
      this.Loader.hide();
    });
  }

  // OpenRiskProfilePopup(){
  //   //
  //   if(!isNullOrUndefined(sessionStorage.getItem('cIe+MhBUozWO3+mKZd2to=')))
  //   {
  //     this.EnableRiskProfile= sessionStorage.getItem('cIe+MhBUozWO3+mKZd2to='); //
  //     if(this.EnableRiskProfile == 'Y')
  //     {
  //       if(!isNullOrUndefined(sessionStorage.getItem('LWHTWnSDkv4+qaQXsO6tHYU=')))
  //       {
  //         this.RiskProfileLevel=this.EncrdecrService.getDecr(sessionStorage.getItem('LWHTWnSDkv4+qaQXsO6tHYU='));
  //       }

  //       if(!isNullOrUndefined(sessionStorage.getItem('aaIHl0pIiYe71gyyxC/5xA==')))
  //       {
  //         this.RiskProfileStatus= this.EncrdecrService.getDecr(sessionStorage.getItem('aaIHl0pIiYe71gyyxC/5xA=='));
  //        // if(this.RiskProfileStatus != 'Active')
  //           if(this.RiskProfileStatus == 'Expired' || this.RiskProfileStatus == 'Expired Soon')
  //         {
  //           this.bsModelRef = this.bsModelService.show(RiskprofileModelComponent, {
  //             class: "modal-width380 modal-dialog-centered filter-popup-wrapper",
  //             ignoreBackdropClick: true,
  //           });
  //           this.bsModelRef.content.onClose = new Subject<boolean>();
  //           this.bsModelRef.content.action = new Subject<boolean>();
  //           // this.bsModelRef.content.onClose.subscribe((res) => {
  //           //   if (res == true) {
  //           //     this.CallAlertModal("Nominee details updated successfully.");
  //           //   }
  //           // });
  //           // this.bsModelRef.content.action.subscribe((res) => {
  //           //   if (res == true) {

  //           //   }
  //           // });
  //         }
  //       }

  //     }

  //   }


  // }

  // OpenDigitalKYCModel(){
  //   if (this.CompanyName == "AU")
  //   {
  //     if (this.G_UserType == 3)
  //     {
  //      // sessionStorage.setItem("LowPX39uViQtX+83GLeOYFk=", this.G_ClientBasicInfoId);

  //      this.bsModelRef=this.bsModelService.show(DigitalKYCModelComponent,Object.assign("",{
  //       class:"modal-width380 modal-dialog-centered filter-popup-wrapper",
  //       ignoreBackdropClick:true,
  //      }));
  //      this.bsModelRef.content.onClose = new Subject<boolean>();
  //      this.bsModelRef.content.action = new Subject<boolean>();
  //      this.bsModelRef.content.onClose.subscribe((res) => {
  //       if (res == true) {
  //         this.BindPageLoadData();
  //       }
  //     });
  //     }
  //   }
  // }

  BindNomineeData() {

    this.profileService
      .GetClientInfo(this.G_ClientBasicInfoId)
      .then(
        (res: any) => {
          //console.log(JSON.stringify(res));
          if (res != null) {
            if (
              res.Message != null &&
              res.Message != "" &&
              res.Message.indexOf("Not Authorized") > -1
            ) {
              this.Loader.hide();
              this.Logout.LogoutUser();
              return;
            } else {
              //
              // Nominee
              if (res.ArrayOfResponse.length > 0) {
                if (res.ArrayOfResponse[0].nomineeDetails[0].active[0].nominee.length > 0) {
                  let nomineeDetails =
                    res.ArrayOfResponse[0].nomineeDetails[0].active[0].nominee[0];
                  this.nomineetitle = isNullOrUndefined(nomineeDetails.NomineeTitle) && nomineeDetails.NomineeTitle == '' ? '' : nomineeDetails.NomineeTitle;
                  this.nomineename = nomineeDetails.invnomname;
                  this.Isnominated = true;
                  this.IsNotNominated = false;
                  $("#AddNomineeModel").modal({
                    backdrop: 'static',
                    keyboard: false
                  });
                  $('#AddNomineeModelContentmodels').text('Dear Customer, You have nominated ' + this.nomineetitle + ' ' + this.nomineename + ' for your Investments. Do you wish to continue?');

                }
                else {
                  this.IsNotNominated = true;
                  this.Isnominated = false;
                  $("#AddNomineeModel").modal({
                    backdrop: 'static',
                    keyboard: false
                  });
                  $('#AddNomineeModelContentmodels').text('Dear Customer, Adding a nominee for an Investment is important. Do you wish to add one?');
                }
              }
              else {
                this.Loader.hide();
                this.IsNotNominated = true;
                this.Isnominated = false;
                $("#AddNomineeModel").modal({
                  backdrop: 'static',
                  keyboard: false
                });
                $('#AddNomineeModelContentmodels').text('Dear Customer, Adding a nominee for an Investment is important. Do you wish to add one?');
              }

            }
          }
          this.Loader.hide();
          // this.IsNotNominated = true;
          // this.Isnominated = false;
          //       $("#AddNomineeModel").modal({
          //         backdrop: 'static',
          //         keyboard: false
          //       });
          //       $('#AddNomineeModelContentmodels').text('Dear Customer, Adding a nominee for an Investment is important. Do you wish to add one?');
        },
        (err) => {
          this.Loader.hide();
          //console.log(err);
        }
      );
  }

  BindPageLoadData() {


    debugger;
    this.OnInitStart = new Date().getTime();
    this.Loader.show();
    this.IsIFA = sessionStorage.getItem('Vbhs@#%LMKIo=') == 'C' ? false : true;
    this.SetViewPort(window.innerWidth);

    this.ColorsArr = this.ColorsArrayService.ColorsArray(this.CompanyName);
    // this.UserTrackingService.SaveEvent('1').subscribe(
    //   (res: any) => {
    //     //let userLogId = res.ArrayOfResponse[0].UserLogId;
    //   }
    // );
    if (sessionStorage.getItem('Gthru7Je7n3eilo') != undefined &&
      sessionStorage.getItem('Gthru7Je7n3eilo') != null) {
      if (this.EncrdecrService.getDecr(sessionStorage.getItem('Gthru7Je7n3eilo')) == 'yes') {
        $("#CompleteProfileModal").modal({
          backdrop: 'static',
          keyboard: false
        });
        sessionStorage.removeItem('Gthru7Je7n3eilo');
      }
    }
    this.ExchangeFlag = sessionStorage.getItem('E#$%#XCha7%*=');


    const gsh = sessionStorage.getItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$');
    this.OFSClient = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$')));

    switch (this.ExchangeFlag) {
      case 'BSE':
        this.IsBse = true;
        break;
      case 'NSE':
        this.IsBse = false;
        break;
      case 'B':
        this.IsBse = true;
        break;
      case 'N':
        this.IsBse = false;
        break;
    }
    $('.MainBg').css('min-height', window.innerHeight - 112);
    $(document).ready(function () {
      $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function (data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find('svg');

          // Add replaced image's ID to the new SVG
          if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a');

          // Replace image with new SVG
          $img.replaceWith($svg);

        }, 'xml');
      });
    });
    if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null) {
      if (sessionStorage.getItem('UZT6qHaDZSz66kx') != null && sessionStorage.getItem('UZT6qHaDZSz66kx') != '') {
        this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem('UZT6qHaDZSz66kx'));
      }
      else {
        this.G_ClientBasicInfoId = this.ClientBasicInfoId;
      }

      //this.G_SubBrokerCode = sessionStorage.getItem('Session_SubBrokerCode');
      //alert(this.G_SubBrokerId)
      let familyId = sessionStorage.getItem('hn0bHyGhfpGtrPe');
      if (familyId !== null && familyId !== undefined && familyId !== 'null') {
        this.G_FamilyId = parseInt(this.EncrdecrService.getDecr(familyId)); //Session_Family_ID
      }
      else {
        this.G_FamilyId = 0
      }

      this.GetFamilyGroup(this.G_FamilyId);

    }
    this.loginclientId = this.G_ClientBasicInfoId;
    let LCount = 0;
    // if (sessionStorage.getItem('ySxterqMDG7RY2qTpuzrfA') != undefined
    //   && sessionStorage.getItem('ySxterqMDG7RY2qTpuzrfA') != null
    //   && sessionStorage.getItem('ySxterqMDG7RY2qTpuzrfA') != '') {
    //   LCount = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('ySxterqMDG7RY2qTpuzrfA')));
    //   sessionStorage.removeItem('ySxterqMDG7RY2qTpuzrfA');
    // }
    // if (LCount == 1) {
    //   this.NseOnboardingService.GetClientProfile(this.G_ClientBasicInfoId).subscribe(
    //     (res: any) => {

    //       if (res.Message != null && res.Message != '' && res.Message.indexOf('Not Authorized') > -1) {
    //         this.Loader.hide();
    //         this.Logout.LogoutUser();
    //         return;
    //       }
    //       else {
    //         let BasicDetails = res.ArrayOfResponse[0].personalDetails[0].active[0].firstApplicant[0];
    //         // if (BasicDetails.uccDetails[0].Single.length > 0) {
    //         //   this.GeneratedIIN = BasicDetails.uccDetails[0].Single[0].UccCode;
    //         //   console.log(this.GeneratedIIN);
    //         //   if(this.IsBse && this.OFSClient != 4 && (this.GeneratedIIN == '' || this.GeneratedIIN == null || this.GeneratedIIN == undefined)){
    //         //     $('#NoUCCModal').modal({
    //         //       backdrop:'static',
    //         //       keyboard:false
    //         //     });
    //         //   }
    //         // }else{
    //         //   if(this.IsBse && this.OFSClient != 4 && (this.GeneratedIIN == '' || this.GeneratedIIN == null || this.GeneratedIIN == undefined)){
    //         //     $('#NoUCCModal').modal({
    //         //       backdrop:'static',
    //         //       keyboard:false
    //         //     });
    //         //   }
    //         // }
    //         if (this.OFSClient == 2) {
    //           if (this.GeneratedIIN == '' || this.GeneratedIIN == null || this.GeneratedIIN == undefined) {
    //             this.IsIINGenerated = true;
    //             if (BasicDetails.KYCSource == "1" || BasicDetails.KYCSource == "2") { //KYCSource 1 0r 2  means client has registered for KYC Process
    //               let PANNo = this.EncrdecrService.getDecr(BasicDetails.emailid);
    //               let MobileNo = this.EncrdecrService.getDecr(BasicDetails.Mobno);

    //             this.profileService.CheckKYC(PANNo, MobileNo).subscribe(data => {

    //               if (data.Message == "KYC verified.") {
    //                 this.KYCVerified = true;
    //               }
    //               else {
    //                 this.KYCVerified = false;
    //               }
    //               $("#IINModal").modal({ backdrop: 'static', keyboard: false });

    //               });
    //             }
    //           }
    //         }
    //       }

    //     },
    //     err => {
    //       this.Loader.hide();
    //       ////console.log(err);
    //     });
    // }
    // if(this.IsBse) {
    //   this.getNomineeStatus();
    // }
    if (!!sessionStorage.getItem('bXHnuiS89&#jk##')) {
      let changedId = this.EncrdecrService.getDecr(sessionStorage.getItem('thnjiokgrthn'))
      this.GetClientDashboardDetail(changedId);
    }
    else {
      this.GetClientDashboardDetail(this.G_ClientBasicInfoId);
    }
    this.GetTopFundsData();
    const token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    const ptoken = sessionStorage.getItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294');
    if (token != null && ptoken !== 'false') {
      this.G_SubBrokerId = this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'));
    }
    //#endregion
    //#region  Risk Profile
    //this.OpenRiskProfilePopup();
    //#endregion


  }

  OpenDigitalKycfirstModel() {
    $("#DigitalKYCfirstmodel").modal({
      backdrop: 'static',
      keyboard: false
    });
  }

  HidefirstDigitalKYCPopUp() {
    document.getElementById('DigitalKYCfirstmodel').style.display = 'none';
    this.BindPageLoadData();
  }

  setTaxSaver() {

    sessionStorage.setItem('asjhgdakasdfe', 'jasgduagiyuf');
    this.router.navigate(['goal-planning-bse']);
  }

  setStartWith100() {
    sessionStorage.setItem('jhsihtirjksldf', 'jasgduagiyuf');
    this.router.navigate(['explore-funds']);
  }

  SetNFO() {
    sessionStorage.setItem('sgsgsgsgfyehbjc', 'jasgduagiyuf');
    this.router.navigate(['explore-funds']);
  }

  setSip() {
    sessionStorage.setItem('sjdkhfjishiheriukl', 'jasgduagiyuf');
    // this.router.navigate(['goal-planning-bse']);
    this.router.navigate(['explore-funds']);
  }

  //aditya 20-01-2025
  NavigateTo(page: string) {
    debugger
    sessionStorage.setItem("qazwsxedc1#2&3", this.EncrdecrService.setEncr("true"));
    sessionStorage.removeItem('tyrueiwo');
    switch (page) {
      case "Scheme":
        this.router.navigate(['reports/detailed-holding-report'])
        break;
      case "AMC":
        this.SelectedMfTab = "mf-amc"
        break;
      case "AssetWise":
        this.SelectedMfTab = "AssetWise"
        break;
      case "SubAssetWise":
        this.SelectedMfTab = "SubAssetWise"
        break;
      default:
        break;
    }
    if (page != "Scheme") {
      let clientId = this.EncrdecrService.getDecr(sessionStorage.getItem("thnjiokgrthn"))
      let usertype = this.EncrdecrService.getDecr(sessionStorage.getItem("edcrfvbhunji"))
      sessionStorage.setItem('hgWUIy487$mJwue', this.EncrdecrService.setEncr(`${clientId}#*#${usertype}#*#${this.SelectedMfTab}#*#m#*#${""}#*#${'3'}`));
      this.router.navigate(['reports-new/portfolio-report-combine']);
    }
  }

  GetUCCCode(cbid) {
    this.transaction.GetClientUCCDetails(cbid).then(
      (result: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(result));
        if (res != null) {
          if (
            res.Message != null &&
            res.Message != "" &&
            res.Message.indexOf("Not Authorized") > -1
          ) {
            //this.Loader.hide();
            //this.Logout.LogoutUser();
            return;
          } else {
            if (res.ArrayOfResponse.length > 0) {
              this.G_UCCCode = res.ArrayOfResponse[0].ClientCode;
              this.getClientMandateReportList(this.G_UCCCode);
            }
          }
        }
      },
      (err) => { }
    );
  }

  getClientMandateReportList(ClientId) {

    this.ClientMandateList = [];
    try {
      this.reportservice
        .getClientMandateReportForApproval(ClientId)
        .then((data1) => {
          if (data1 != null) {
            let data = JSON.parse(this.EncrdecrService.getDecr(data1));

            if (data.ArrayOfResponse.length > 0) {
              this.ClientMandateList = data.ArrayOfResponse;
              //console.log()
            }
          }
        });
    }
    catch (err) { }
  }
  // by Ankita 10/3/2025
  ConvertToDate(ipdate, flag = '') {

    let date = '';
    if (ipdate != null && ipdate != '') {
      let d = ipdate.split('T')[0];
      let dd = d.split('-');

      if (flag == 'dash')
        date = `${(dd.toString().replace('/', '-')).replace('/', '-')}`
      else
        date = `${dd[2]}/${dd[1]}/${dd[0]}`
    }
    return date;
  }
  // Added By Ritesh
  ConvertToDate1stPur(ipdate) {
    let date = '';
    if (ipdate != null && ipdate != '') {
      let d = ipdate.split('T')[0];
      let dd = d.split('-');
      let m = parseInt(dd[1]) - 1;
      date = `${dd[2]}/${this.MonthNameArr[m]}/${dd[0]}`
    }
    return date;
  }
  public MonthNameArr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  GetSummaryReport(){
    let data:any;
    const date = new Date();
    const formattedDate = date.toISOString().slice(0, 10);
    data = {
      "Clientid": this.G_ClientBasicInfoId ,
      "UserId":  this.G_ClientBasicInfoId ,
      "UserType": this.G_UserType ,
      "ToDate":formattedDate,
      "FolioType": "Active",
      "RoleID":this.G_ROLEID
    }
    this.reportservice.GetPortfolioComprehensiveReport(data).subscribe(data_res => {
           let sucess = false;
      if (data != null) {
        let data = JSON.parse(this.EncrdecrService.getDecr(data_res));
        if (data.Message != null && data.Message != '' && data.Message.indexOf('Not Authorized') > -1) {
          this.Loader.hide();
          this.Logout.LogoutUser();
          return;
        }
        else {
          if (data.ArrayOfResponse.length == 0) {
            this.Loader.hide();
            this.CallAlertModal('No record found');
          }
          else {
            this.Loader.hide();
            debugger
            let d: any = data.ArrayOfResponse;
            if (d[0].sumsummary == null) {
              this.Loader.hide();
              this.CallAlertModal('No record found');
            }
            else {
              if (d.length > 0) {
                sucess = false;
                let rr = d[0].sumsummary;
                let AMCXIRRsummary = d[0].AMCXIRRsummary;
                let ClassXIRRSummary = d[0].AssetXIRRsummary;
                let CategoryXIRRSummary = d[0].SubAssetXIRRsummary;
                let TotalXIRRSummary = d[0].TotalXIRRsummary;
                if (rr.length > 0) {
                  let TotalCV_Scheme = rr.reduce((total, per) => total + parseFloat(per.Currentvalue), 0);
                  rr.map((a, index) => {
                    let inv = `${a.ClientName}`
                    let invNew = `${a.ClientName} , ${a.PAN}`
                    if (a.JointPAN1 != '' && a.JointPAN1 != null) {
                      inv = `${inv} — ${a.JointPAN1}`
                      invNew = `${invNew} — ${a.JointPAN1}`
                      if (a.JointPAN2 != '' && a.JointPAN2 != null) {
                        inv = `${inv} — ${a.JointPAN2}`
                        invNew = `${invNew} — ${a.JointPAN2}`
                      }
                      else {
                        inv = `${inv}`;
                        invNew = `${invNew}`;
                      }
                    }
                    if (a.Field2 != null && a.Field2 != undefined) {
                      inv = `${inv} — , ${a.Field2}`
                      invNew = `${invNew}  , ${a.Field2}`
                    }
                    a.InvestorName = inv;
                    if (a.SIPFlag == 1) {
                      a.SIPFlag = 'Yes';
                    }
                    else {
                      a.SIPFlag = 'No';
                    }
                    if (a.STPFlag == 1) {
                      a.STPFlag = 'Yes';
                    }
                    else {
                      a.STPFlag = 'No';
                    }
                    if (a.SWPFlag == 1) {
                      a.SWPFlag = 'Yes';
                    }
                    else {
                      a.SWPFlag = 'No';
                    }
                    a.FirstPurDate = this.ConvertToDate1stPur(a.FirstPurDate);
                    a.NAVDate = this.ConvertToDate(a.NAVDate);
                    debugger
                    a.SchemeName = `${a.SchemeName} (${a.Folio}) | ${a.FirstPurDate} | ${a.SIPFlag} | ${a.STPFlag} | ${a.SWPFlag} | ${a.TotalTran} | ${a.Folio} | ${a.SchemeCode}`;
                    // a.SchemeName = `${a.SchemeName} (${a.Folio}) | 1st Purchase: ${a.FirstPurDate} | SIP: ${a.SIPFlag} |
                    // STP: ${a.STPFlag} | SWP: ${a.SWPFlag} | Total Trans: ${a.TotalTran}`;
                    if (!!TotalCV_Scheme && TotalCV_Scheme != 0) {
                      a.PercOfPortfolio = ((parseFloat(a.Currentvalue) / TotalCV_Scheme) * 100).toFixed(2);
                    }
                    else {
                      a.PercOfPortfolio = parseFloat('0')
                    }
                    //a.PercOfPortfolio = ((parseFloat(a.Currentvalue) / TotalCV_Scheme) * 100).toFixed(2);
                    if (!!TotalCV_Scheme && TotalCV_Scheme != 0) {
                      a.PercOfPortfolio = ((parseFloat(a.Currentvalue) / TotalCV_Scheme) * 100).toFixed(2);
                    }
                    else {
                      a.PercOfPortfolio = parseFloat('0')
                    }
                    a.TotalGainLoss = (parseFloat(a.GainLoss) + parseFloat(a.GainLossRealised)).toFixed(2);


                    let InvestorArray = invNew.split(',')
                    let Holdingtype: any
                    let Invname: any
                    let pan: any
                    if (InvestorArray.length > 2) {
                      Invname = invNew.split(',')[0].trim()
                      pan = invNew.split(',')[1].trim()
                      Holdingtype = invNew.split(',')[2].trim()
                    }
                    else {
                      Invname = invNew.split(',')[0].trim()
                      pan = invNew.split(',')[1].trim()
                      Holdingtype = ''
                    }


                    let Schemename = a.SchemeName.split('(')[0].trim()
                    let Foliono = a.SchemeName.split(' (')[1].trim()

                    let startIndex = Foliono.indexOf('(');
                    let endIndex = Foliono.indexOf(')', startIndex);
                    let extractedText = Foliono.substring(startIndex + 1, endIndex);

                    a.CurrentValue = parseFloat(a.CurrentValue);
                    a.CostCurrentValue = parseFloat(a.CostCurrentValue)
                    a.Unit = parseFloat(a.Unit)

                    let SingleDataAMC_detail = [index + 1, Invname, pan, Holdingtype, a.AmcName, Schemename, extractedText, a.FirstPurDate, a.SIPFlag, a.STPFlag, a.SWPFlag, a.TotalTran,
                    parseFloat(a.InvestmentAmount.toFixed(2)),
                    parseFloat(a.Currentvalue.toFixed(2)),
                    parseFloat(a.CostCurrentValue.toFixed(2)),
                    parseFloat(parseFloat(a.Redemption).toFixed(2)),
                    parseFloat(parseFloat(a.DividendReinvest).toFixed(2)),
                    a.DividentPayoutUnitsPurchased,
                    parseFloat(parseFloat(a.UnitsPurchased).toFixed(2)),
                    parseFloat(parseFloat(a.UnisReinvested).toFixed(2)),
                    parseFloat(parseFloat(a.UnitsSold).toFixed(2)),
                    a.Unit, a.NAV, a.NAVDate, a.PurWtAvg, a.GainLossRealised, a.GainLoss, a.TotalGainLoss, a.Absreturn, a.XIRR, a.XIRRBench, a.PercOfPortfolio];
                    // this.ExportToExcelDataAMC_detail.push(SingleDataAMC_detail);
                    let SingleDataClass_detail = [index + 1, Invname, pan, Holdingtype, a.ClassName, Schemename, extractedText, a.FirstPurDate, a.SIPFlag, a.STPFlag, a.SWPFlag, a.TotalTran,
                    parseFloat(a.InvestmentAmount.toFixed(2)),
                    parseFloat(a.Currentvalue.toFixed(2)),
                    parseFloat(a.CostCurrentValue.toFixed(2)),
                    parseFloat(parseFloat(a.Redemption).toFixed(2)),
                    parseFloat(parseFloat(a.DividendReinvest).toFixed(2)),
                    a.DividentPayoutUnitsPurchased,
                    parseFloat(parseFloat(a.UnitsPurchased).toFixed(2)),
                    parseFloat(parseFloat(a.UnisReinvested).toFixed(2)),
                    parseFloat(parseFloat(a.UnitsSold).toFixed(2)),
                    a.Unit, a.NAV, a.NAVDate, a.PurWtAvg, a.GainLossRealised, a.GainLoss, a.TotalGainLoss, a.Absreturn, a.XIRR, a.XIRRBench, a.PercOfPortfolio];
                    // this.ExportToExcelDataClass_detail.push(SingleDataClass_detail);
                    let SingleDataCategory_detail = [index + 1, Invname, pan, Holdingtype, a.SubCategoryName, Schemename, extractedText, a.FirstPurDate, a.SIPFlag, a.STPFlag, a.SWPFlag, a.TotalTran,
                    parseFloat(a.InvestmentAmount.toFixed(2)),
                    parseFloat(a.Currentvalue.toFixed(2)),
                    parseFloat(a.CostCurrentValue.toFixed(2)),
                    parseFloat(parseFloat(a.Redemption).toFixed(2)),
                    parseFloat(parseFloat(a.DividendReinvest).toFixed(2)),
                    a.DividentPayoutUnitsPurchased,
                    parseFloat(parseFloat(a.UnitsPurchased).toFixed(2)),
                    parseFloat(parseFloat(a.UnisReinvested).toFixed(2)),
                    parseFloat(parseFloat(a.UnitsSold).toFixed(2)),
                    a.Unit, a.NAV, a.NAVDate, a.PurWtAvg, a.GainLossRealised, a.GainLoss, a.TotalGainLoss, a.Absreturn, a.XIRR, a.XIRRBench, a.PercOfPortfolio];
                    // this.ExportToExcelDataCategory_detail.push(SingleDataCategory_detail);

                  });
                  let InvestorWise = rr.reduce((acc, curr) => {
                    if (!acc[curr.InvestorName]) acc[curr.InvestorName] = [];
                    acc[curr.InvestorName].push(curr);
                    return acc;
                  }, {});
                 
                  console.log(rr)
                  let SchemeName = rr.map(item => item.SchemeName);
                  console.log(SchemeName);

                  let SchemeName2 = SchemeName.map(item => item.split(' | ')[0]);
                  console.log(SchemeName2);
                  rr.forEach(element => {
                    element.SchemeName = element.SchemeName.split(' | ')[0]
                  });
                  console.log("rr  ===>", rr);
                  let TempReportData = rr.SchemeName;
                  let TempReportData2 = rr.filter(
                    (a) => a.SchemeName
                  );
                  console.log(TempReportData2);
                  // console.log("Summary Report Data :", rr)
                  rr.map(a => {
                    a.InvestmentAmount = this.ConvertToIndianRsWithDecimal(a.InvestmentAmount);
                    a.Currentvalue = this.ConvertToNegative(this.ConvertToIndianRsWithDecimal(a.Currentvalue));
                    a.CostCurrentValue = this.ConvertToNegative(this.ConvertToIndianRsWithDecimal(a.CostCurrentValue));
                    a.Redemption = this.ConvertToNegative(this.ConvertToIndianRsWithDecimal(parseFloat(a.Redemption)));
                    a.DividendReinvest = this.ConvertToNegative(this.ConvertToIndianRsWithDecimal(parseFloat(a.DividendReinvest)));
                    a.DividentPayout = this.ConvertToNegative(this.ConvertToIndianRsWithDecimal(parseFloat(a.DividentPayout)));
                    a.UnitsPurchased = this.ConvertToNegative(parseFloat(a.UnitsPurchased).toFixed(4));
                    a.UnisReinvested = this.ConvertToNegative(parseFloat(a.UnisReinvested).toFixed(4));
                    a.UnitsSold = this.ConvertToNegative(parseFloat(a.UnitsSold).toFixed(4));
                    a.Unit = this.ConvertToNegative(parseFloat(a.Unit).toFixed(4));
                    a.NAV = this.ConvertToNegative(parseFloat(a.NAV).toFixed(4));
                    a.PurWtAvg = this.ConvertToNegative(parseFloat(a.PurWtAvg).toFixed(4));
                    a.GainLossRealised = this.ConvertToNegative(this.ConvertToIndianRsWithDecimal(parseFloat(a.GainLossRealised)));
                    a.GainLoss = this.ConvertToNegative(this.ConvertToIndianRsWithDecimal(a.GainLoss));
                    a.TotalGainLoss = this.ConvertToNegative(this.ConvertToIndianRsWithDecimal(parseFloat(a.TotalGainLoss)));
                    a.Absreturn = this.ConvertToNegative((a.Absreturn).toString());
                    a.XIRR = this.ConvertToNegative((a.XIRR).toString());
                    a.XIRRBench = this.ConvertToNegative((a.XIRRBench).toString());
                    a.PercOfPortfolio = this.ConvertToNegative((a.PercOfPortfolio).toString());
                    // a.SchemeName = SchemeName2;
                  });
                  this.ReportData = rr;

                  let t: any = [];
                  rr.reduce(function (acc, curr) {
                    debugger
                    let findIfInvExist = acc.findIndex(function (item) {
                      return item.InvestorName === curr.InvestorName;
                    })
                    if (findIfInvExist === -1) {
                      let obj = {
                        'InvestorName': curr.InvestorName,
                        "AmcName": [curr]
                      }
                      acc.push(obj)
                      let obj2 = {
                        'InvestorName': curr.InvestorName,
                        "AmcName": []
                      }
                      t.push(obj2)
                      t.map(a => {
                        if (a.InvestorName == curr.InvestorName) {
                          a.AmcName = [];
                          let obj = {
                            'AmcName': curr.AmcName,
                            "SchemeName": [curr]
                          }
                          a.AmcName.push(obj)
                        }
                      })
                    }
                    else {
                      acc[findIfInvExist].AmcName.push(curr);
                      acc[findIfInvExist].AmcName.reduce(function (acc1, curr1) {
                        let findIfAMCExist = acc1.findIndex(function (item1) {
                          return item1.AmcName === curr1.AmcName;
                        })
                        if (findIfAMCExist === -1) {
                          let obj = {
                            'AmcName': curr1.AmcName,
                            "SchemeName": [curr1]
                          }
                          acc1.push(obj)
                        }
                        else {
                          acc1[findIfAMCExist].SchemeName.push(curr1);
                        }
                        t.map(a => {
                          if (a.InvestorName == curr1.InvestorName) {
                            a.AmcName = [];
                            acc1.map(b => {
                              a.AmcName.push(b)
                            })
                          }
                        })
                        return acc1;
                      }, []);
                    }
                    return acc;
                  }, []);
                  const totalAmt = rr.reduce((a,b)=>{
                    var t = (parseFloat(a.toString().replace(/,/g, '').replace('(', '-').replace(')', '')) + parseFloat(b.InvestmentAmount.toString().replace(/,/g, '').replace('(', '-').replace(')', '')))
                    return t.toFixed(2);
                  },0)
                  const CostCurrentValue = rr.reduce((a,b)=>{
                    var t =  (parseFloat(a.toString().replace(/,/g, '').replace('(', '').replace(')', '')) + parseFloat(b.CostCurrentValue.toString().replace(/,/g, '').replace('(', '').replace(')', '')));
                    return t.toFixed(2);
                  },0)
                  const PurWtAvg = rr.reduce((a,b)=>{
                    var t =  (parseFloat(a.toString().replace(/,/g, '').replace('(', '').replace(')', '')) + parseFloat(b.PurWtAvg.toString().replace(/,/g, '').replace('(', '').replace(')', '')));
                    return t.toFixed(2);
                  },0)
                  const DividendReinvest = rr.reduce((a,b)=>{
                    var t =  (parseFloat(a.toString().replace(/,/g, '').replace('(', '').replace(')', '')) + parseFloat(b.DividendReinvest.toString().replace(/,/g, '').replace('(', '').replace(')', '')));
                    return t.toFixed(2);
                  },0)
                  const Redemption = rr.reduce((a,b)=>{
                    var t =  (parseFloat(a.toString().replace(/,/g, '').replace('(', '').replace(')', '')) + parseFloat(b.Redemption.toString().replace(/,/g, '').replace('(', '').replace(')', '')));
                    return t.toFixed(2);
                  },0)
                  const GainLossRealised = rr.reduce((a,b)=>{
                    var t =  (parseFloat(a.toString().replace(/,/g, '').replace('(', '').replace(')', '')) + parseFloat(b.GainLossRealised.toString().replace(/,/g, '').replace('(', '').replace(')', '')));
                    return t.toFixed(2);
                  },0)
                  const GainLoss = rr.reduce((a,b)=>{
                    var t =  (parseFloat(a.toString().replace(/,/g, '').replace('(', '').replace(')', '')) + parseFloat(b.GainLoss.toString().replace(/,/g, '').replace('(', '').replace(')', '')));
                    return t.toFixed(2);
                  },0)
                  const TotalCurrentvalue = rr.reduce((a,b)=>{
                    var t = (parseFloat(a.toString().replace(/,/g, '').replace('(', '').replace(')', '')) + parseFloat(b.Currentvalue.toString().replace(/,/g, '').replace('(', '').replace(')', '')));
                    return t.toFixed(2);
                  },0)
                  const TotalGainLoss = rr.reduce((a,b)=>{
                    var t = (parseFloat(a.toString().replace(/,/g, '').replace('(', '-').replace(')', '')) + parseFloat(b.TotalGainLoss.toString().replace(/,/g, '').replace('(', '-').replace(')', '')))
                    return t.toFixed(2);
                  },0)
                  console.log('PurWtAvg ----', PurWtAvg)
                  this.SummaryReportTotal = [{
                    totalAmt: totalAmt,
                    totalCurrAmount: TotalCurrentvalue,
                    TotalXIRR: TotalXIRRSummary[0].XIRR,
                    TotalGainLoss: TotalGainLoss,
                    CostCurrentValue: CostCurrentValue,
                    PurWtAvg: PurWtAvg,
                    DividendReinvest: DividendReinvest,
                    Redemption: Redemption,
                    GainLossRealised: GainLossRealised,
                    GainLoss: GainLoss
                  }];
                  console.log(' this.SummaryReportTotal ----',  this.SummaryReportTotal)
                  sucess = false;
                }
                // this.IsShowReport = true;
              }
            }

          }
        }
      }
      else {
        this.Loader.hide();
      }

    });
  }
  Remove() {
    debugger
    this.path = window.location.href;
    this.router.navigate(["/comprehensive"], { relativeTo: this.route });
    if (this.path == "/comprehensive") {
      window.location.reload();
    }
  }
}
